import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubscriptionState } from './subscription.reducer';

export const selectSubscriptionState = createFeatureSelector<SubscriptionState>('subscription');

export const selectSubscriptionData = createSelector(
  selectSubscriptionState,
  (state: SubscriptionState) => ({ ai_tokens: state.ai_tokens, credits: state.credits, on_trial: state.on_trial, subscribed: state.subscribed})
);

export const selectCredits = createSelector(
  selectSubscriptionState,
  (state) => state.credits
);

export const selectAITokens = createSelector(
  selectSubscriptionState,
  (state) => state.ai_tokens
);

export const selectUser = createSelector(
  selectSubscriptionState,
  (state) => state.user
);

export const selectLoading = createSelector(
  selectSubscriptionState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectSubscriptionState,
  (state) => state.error
);

// New selectors for credits balance API fields
export const selectCurrentBalance = createSelector(
  selectSubscriptionState,
  (state) => state.current_balance
);

export const selectLastAllocationDate = createSelector(
  selectSubscriptionState,
  (state) => state.last_allocation_date
);

export const selectNextAllocationDate = createSelector(
  selectSubscriptionState,
  (state) => state.next_allocation_date
);

export const selectSubscriptionAmount = createSelector(
  selectSubscriptionState,
  (state) => state.subscription_amount
);
